import {
  EuiButton,
  EuiPageContentBody,
  EuiPageHeader,
  EuiPanel,
  EuiSpacer,
} from "@elastic/eui";
import isEmpty from "lodash/isEmpty";
import React, { FC, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import omit from "lodash/omit";
import CustomizeForm from "../../../components/common/form";
import { Paths } from "../../../constants";
import { getListRoles } from "../../../redux";
import { updateProfile } from "../../../redux/actions/profile";
import { validation } from "../../../utils";
import { columns } from "../column";
import { result } from "lodash";

interface IFormInput {
  code: string;
  email: string;
  name: string;
  phone: string;
  username: string;
  status: string;
  type: string;
}

const Edit: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profile = useSelector(
    (state: RootStateOrAny) => state?.profile?.data || {}
  );

  useEffect(() => {
    dispatch(getListRoles({ limit: 1000, offset: 0 }));
  }, []);

  useEffect(() => {
    if (!isEmpty(profile)) {
      reset({ ...profile });
    }
  }, [profile]);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<IFormInput>({
    defaultValues: { ...profile },
    resolver: validation.profile.edit(),
  });

  const onSubmit = (data: any) => {
    const result = !data?.password ? omit(data, ["password"]) : data;
    dispatch(updateProfile(result));
  };

  const ars = [
    {
      name: "code",
      label: "Mã",
      isDisable: true,
      type: "input",
    },
    {
      name: "email",
      label: "Email",
      type: "input",
    },
    { name: "name", label: "Tên", type: "input" },
    {
      name: "phone",
      label: "Số điện thoại",
      type: "input",
    },
    {
      name: "username",
      label: "Tên đăng nhập",
      type: "input",
      isDisable: true,
    },
    {
      name: "status",
      label: "Trạng thái",
      type: "select",
      isDisable: true,
      options: [
        { value: "ACTIVE", text: "Hoạt động" },
        { value: "BLOCKED", text: "Chặn" },
      ],
    },
    {
      name: "password",
      label: "Mật khẩu",
      type: "input",
    },
  ];

  return (
    <>
      <EuiPageHeader
        bottomBorder
        className="mtb-page-header"
        pageTitle="Cập nhật"
        rightSideItems={[
          <EuiButton
            iconSide="left"
            iconType="arrowLeft"
            onClick={() => navigate(Paths.USER.LIST)}
          >
            Quay lại
          </EuiButton>,
        ]}
      />
      <EuiSpacer />
      <EuiPageContentBody>
        <EuiPanel hasBorder>
          <form onSubmit={handleSubmit(onSubmit)}>
            {ars.map((item, index: number) => (
              <CustomizeForm
                key={index}
                name={item.name}
                control={control}
                label={item.label}
                errors={errors}
                isDisable={item?.isDisable || false}
                type={item.type}
                options={item.options}
              />
            ))}

            <EuiButton type="submit" color="primary">
              Lưu
            </EuiButton>
          </form>
        </EuiPanel>
      </EuiPageContentBody>
    </>
  );
};

export default Edit;
